import { useDispatch } from 'react-redux';
import Form from '../../../common/Form';
import { closeModalAction } from '../../../actions/modal';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import RenderRemarksInput from '../../../components/Inputs/RenderRemarksInput';
import { addAttributes } from '../../../actions/service_request';
import { AttributeKeys } from '../TicketController';

const formName = 'Add_issue_category';

export const AddIssueCategory = ({ ticket_id, org_id }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const defaultValues = {}
    const methods = useForm({ defaultValues, mode: 'all' });

    const submit = (formValues) => {
        let value = {};
        if (formValues.issue_category && formValues.issue_category.value === 'create_this_issue') {
            value = { str: formValues.issue_category.label };
        } else if (formValues.issue_category) {
            value = { str: formValues.issue_category.label, id: formValues.issue_category.id };
        }

        dispatch(addAttributes({ ticketId: ticket_id, key: AttributeKeys.issue_category, payload: { value, label: 'Issue Category' }, formName }));
    };

    return (<>
        <Form
            methods={methods}
            onSubmit={submit}
            submitButtonText={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <div className='p-4'>
                <RenderRemarksInput org_id={org_id} name='issue_category' label='Issue Category' category='ISSUE_CATEGORY' />
            </div>
        </Form>
    </>)
}